module.exports = __webpack_public_path__ + "static/media/implantes.929e52b3.png";